import axios from "axios";
import { esopBaseURL } from "../../../Configuration/API_URL";

const api = axios.create({
  baseURL: esopBaseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ssoToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default api;
